import QueryString from "qs";
import { useCallback, useEffect, useState } from "react";
import func from "@uikit/func";
import { api } from "../../utils/InstanceAPI";

const initializePage = {
  currIndex: 1,
  totalPage: 1,
};

const useJdShopping = firstPageDate => {
  const [list, setList] = useState([]);
  const [page, setPage] = useState(initializePage);
  const [keywords, setKeywords] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchData = async ({ keyword, page }) => {
    try {
      setLoading(true);
      return await api
        .get(`/be/svc-adapter/jd/search${QueryString.stringify({ keyword, page }, { addQueryPrefix: true })}`)
        .then(response => response.json());
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const getNewData = async () => {
    const result = await fetchData({
      keyword: keywords,
    });
    setPage(result.data.page);
    setList(result.data.items);
  };

  const getLoadMoreData = async () => {
    const result = await fetchData({
      keyword: keywords,
      page: page.currIndex + 1,
    });
    setPage(result.data.page);
    setList(list => [...list, ...result.data.items]);
  };

  const resetNodeDateState = useCallback(() => {
    const { items = [], page = initializePage, source = "" } = firstPageDate;
    setList(items);
    setPage(page);
    if (func.isEmpty(source)) return;
    const { keyword } = QueryString.parse(source.slice(source.indexOf("?")), {
      ignoreQueryPrefix: true,
    });
    setKeywords(keyword);
  }, [firstPageDate]);

  useEffect(() => {
    resetNodeDateState();
  }, [firstPageDate]);

  const noMore = page.currIndex >= page.totalPage || list.length === 0;

  return {
    list,
    loading,
    noMore,
    keywords,
    getNewData,
    getLoadMoreData,
    setKeywords,
  };
};

export default useJdShopping;
